// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-wrapper .navbar {
  padding: 0px !important;
  justify-content: flex-start !important;
}
.header-wrapper nav {
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
}
.header-wrapper nav .navbar-start a {
  cursor: default;
}
.header-wrapper nav .navbar-start .nav-item {
  background: #fff;
  border-radius: 100%;
  padding: 5px;
  margin-right: 10px;
  width: 50px;
  height: 50px;
}
.header-wrapper nav .navbar-start .nav-item img {
  width: 100% !important;
}
.header-wrapper nav .navbar-start .company-detail {
  display: flex;
  align-items: center;
  flex-direction: row;
}
.header-wrapper nav .navbar-start .company-name {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  line-height: 1.2rem;
}
.header-wrapper nav .navbar-end .navbar-link::after {
  border-color: var(--menuSelectColor) !important;
}
.header-wrapper nav .navbar-end .channel-actions {
  width: 250px !important;
  margin-top: 12px;
}
.header-wrapper nav .navbar-end .channel-actions h2 {
  position: absolute;
  right: 22em;
  top: 1.1em;
  font-weight: 500;
  color: var(--whiteColor);
}
.header-wrapper nav .navbar-end .channel-actions .company_list {
  text-transform: capitalize;
}
.header-wrapper .navbar-link {
  height: 60px;
}
.header-wrapper .navbar-link:hover {
  background-color: rgba(0, 0, 0, 0.1) !important;
}
.header-wrapper .navbar-link img {
  border-radius: 100%;
}
.header-wrapper .navbar-item img {
  max-height: 2.15rem;
}
.header-wrapper .navbar-link .icon {
  position: absolute;
  top: 30px;
  right: 35px;
}
.header-wrapper .navbar-link .fa {
  font-size: 12px !important;
}
.header-wrapper .navbar-dropdown .navbar-item .fa {
  font-size: 12px !important;
  margin-right: 10px;
}
.header-wrapper .nested.dropdown:hover > .dropdown-menu {
  display: block;
}
.header-wrapper .nested.dropdown .dropdown-menu {
  top: -13px;
  left: -193px;
}
.header-wrapper .nested.dropdown .dropdown-content .has-text-grey {
  padding: 4px 15px;
}
.header-wrapper .nested.dropdown .dropdown-menu input {
  cursor: inherit;
}
.header-wrapper .nested.dropdown .dropdown-trigger::after {
  content: "\\f105";
  font-family: FontAwesome;
  position: absolute;
  right: 14px;
}
.header-wrapper .nested.dropdown .fa {
  margin-top: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/header/header.component.scss"],"names":[],"mappings":"AACI;EACI,uBAAA;EACA,sCAAA;AAAR;AAGI;EAGI,iDAAA;AAHR;AAMY;EACI,eAAA;AAJhB;AAOY;EACI,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AALhB;AAMgB;EACI,sBAAA;AAJpB;AASY;EAEI,aAAA;EACA,mBAAA;EACA,mBAAA;AARhB;AAWY;EACI,aAAA;EACA,2BAAA;EACA,sBAAA;EACA,mBAAA;AAThB;AAcY;EACI,+CAAA;AAZhB;AAeY;EACI,uBAAA;EACA,gBAAA;AAbhB;AAegB;EACI,kBAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;EACA,wBAAA;AAbpB;AAgBgB;EACI,0BAAA;AAdpB;AAqBI;EACI,YAAA;AAnBR;AAqBQ;EACI,+CAAA;AAnBZ;AAsBQ;EACI,mBAAA;AApBZ;AAwBI;EACI,mBAAA;AAtBR;AAyBI;EACI,kBAAA;EACA,SAAA;EACA,WAAA;AAvBR;AA0BI;EACI,0BAAA;AAxBR;AA6BY;EACI,0BAAA;EACA,kBAAA;AA3BhB;AAiCQ;EACI,cAAA;AA/BZ;AAkCQ;EACI,UAAA;EACA,YAAA;AAhCZ;AAoCQ;EACI,iBAAA;AAlCZ;AAqCQ;EACI,eAAA;AAnCZ;AAsCQ;EACI,gBAAA;EACA,wBAAA;EACA,kBAAA;EACA,WAAA;AApCZ;AAuCQ;EACI,eAAA;AArCZ","sourcesContent":[".header-wrapper {\n    .navbar {\n        padding: 0px !important;\n        justify-content: flex-start !important;\n    }\n\n    nav {\n        //background: var(--primaryColor);\n        // background:#fff;\n        box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n\n        .navbar-start {\n            a {\n                cursor: default;\n            }\n\n            .nav-item {\n                background: #fff;\n                border-radius: 100%;\n                padding: 5px;\n                margin-right: 10px;\n                width: 50px;\n                height: 50px;\n                img {\n                    width: 100% !important;\n                }\n\n            }\n\n            .company-detail {\n\n                display: flex;\n                align-items: center;\n                flex-direction: row;\n            }\n\n            .company-name{\n                display: flex;\n                justify-content: flex-start;\n                flex-direction: column;\n                line-height: 1.2rem;\n             }\n        }\n\n        .navbar-end {\n            .navbar-link::after {\n                border-color: var(--menuSelectColor) !important;\n            }\n\n            .channel-actions {\n                width: 250px !important;\n                margin-top: 12px;\n\n                h2 {\n                    position: absolute;\n                    right: 22em;\n                    top: 1.1em;\n                    font-weight: 500;\n                    color: var(--whiteColor);\n                }\n\n                .company_list {\n                    text-transform: capitalize;\n               \n                }\n            }\n        }\n    }\n\n    .navbar-link {\n        height: 60px;\n\n        &:hover {\n            background-color: rgba(0, 0, 0, 0.1) !important;\n        }\n\n        img {\n            border-radius: 100%;\n        }\n    }\n\n    .navbar-item img {\n        max-height: 2.15rem;\n    }\n\n    .navbar-link .icon {\n        position: absolute;\n        top: 30px;\n        right: 35px;\n    }\n\n    .navbar-link .fa {\n        font-size: 12px !important;\n    }\n\n    .navbar-dropdown {\n        .navbar-item {\n            .fa {\n                font-size: 12px !important;\n                margin-right: 10px;\n            }\n        }\n    }\n\n    .nested.dropdown {\n        &:hover>.dropdown-menu {\n            display: block;\n        }\n\n        .dropdown-menu {\n            top: -13px;\n            left: -193px;\n            \n        }\n\n        .dropdown-content .has-text-grey {\n            padding: 4px 15px;\n        }\n\n        .dropdown-menu input {\n            cursor: inherit;\n        }\n\n        .dropdown-trigger::after {\n            content: \"\\f105\";\n            font-family: FontAwesome;\n            position: absolute;\n            right: 14px;\n        }\n\n        .fa {\n            margin-top: 5px;\n        }\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
